export const ALERT_SHOW_TIMEOUT = 8000;
export const ALERT_ANIMATE_TIMEOUT = 250;
